import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { ShieldCheck, ShieldX, Loader2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";
import { errText } from "@/lib/aadhaar";

export default function VerifyId() {
  const { L } = useLang();
  const { code } = useParams();
  const [sp] = useSearchParams();
  const [r, setR] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/id/verify/${encodeURIComponent(code)}`, { params: sp.get("exam") ? { exam: sp.get("exam") } : {} })
      .then((x) => setR(x.data)).catch((e) => setErr(errText(e.response?.data?.detail, "Not found")));
  }, [code, sp]);

  const ok = r?.valid;
  return (
    <div className="min-h-[75vh] rs-radial grid place-items-center px-5 py-14 text-[#0A192F]" data-testid="verify-id-page">
      <div className="w-full max-w-md rounded-3xl border border-slate-200 bg-white/90 backdrop-blur-xl p-8">
        {!r && !err && <Loader2 className="w-8 h-8 animate-spin text-[#007A8A] mx-auto" />}
        {err && <div className="text-center" data-testid="verify-id-invalid"><ShieldX className="w-14 h-14 text-[#FF3B3B] mx-auto" /><h1 className="mt-3 text-2xl font-extrabold">{L("Not verified", "सत्यापित नहीं")}</h1><p className="text-slate-500 text-sm mt-1">{err}</p></div>}
        {r && (
          <div data-testid="verify-id-result">
            <div className="text-center">
              {ok ? <ShieldCheck className="w-14 h-14 text-emerald-600 mx-auto" /> : <ShieldX className="w-14 h-14 text-amber-700 mx-auto" />}
              <h1 className="mt-3 text-2xl font-extrabold" data-testid="verify-id-status">{ok ? L("Verified RoboSpark student", "सत्यापित RoboSpark छात्र") : L("ID card expired", "ID कार्ड की वैधता खत्म")}</h1>
            </div>
            <dl className="mt-6 grid grid-cols-2 gap-3 text-sm">
              {[[L("Name", "नाम"), r.student_name], [L("Student ID", "छात्र ID"), r.student_code], [L("Roll no.", "रोल नं."), r.roll_no], [L("Program", "प्रोग्राम"), r.program], [L("Class", "कक्षा"), r.class_grade], [L("City", "शहर"), r.city], [L("Valid till", "वैधता"), r.valid_till]].map(([k, v]) => (
                <div key={k}><dt className="text-[11px] uppercase tracking-widest text-slate-500">{k}</dt><dd className="font-bold">{v}</dd></div>
              ))}
            </dl>
            {r.exam && <div className="mt-5 rounded-2xl bg-[#F0F4F8] border border-[#00E5FF]/30 p-4 text-sm" data-testid="verify-id-exam"><div className="text-[11px] uppercase tracking-widest text-[#007A8A]">{L("Admit card for", "एडमिट कार्ड")}</div><div className="font-bold">{r.exam.title}</div><div className="text-slate-500">{r.exam.date} · {r.exam.start_time}</div></div>}
          </div>
        )}
      </div>
    </div>
  );
}
